import { Settings2, Users, X } from 'lucide-react';
import type { AuthenticatedUser, EventSummary } from '../../types';
import type { ModuleKey } from './modules';

interface OnboardingDialogProps {
  user: AuthenticatedUser;
  teamRooms: EventSummary[];
  onSelect: (key: ModuleKey) => void;
  onClose: () => void;
}

export function OnboardingDialog({ user, teamRooms, onSelect, onClose }: OnboardingDialogProps) {
  const showSetup = user.caps.events;
  const showTeam = user.org && teamRooms.length > 0;

  return (
    <div className="dialog-backdrop" role="presentation" onMouseDown={onClose}>
      <section className="dialog-card onboarding-dialog" role="dialog" aria-modal="true" aria-labelledby="onboarding-title" onMouseDown={(event) => event.stopPropagation()}>
        <header className="dialog-header">
          <div>
            <h2 id="onboarding-title">Welcome{user.name ? `, ${user.name.split(' ')[0]}` : ''}</h2>
            <p>How do you want to start today?</p>
          </div>
          <button className="icon-button" type="button" onClick={onClose} aria-label="Close room selection" title="Close"><X size={19} /></button>
        </header>
        <div className={`onboarding-options ${showSetup && showTeam ? 'two-columns' : ''}`}>
          {showSetup ? (
            <section className="onboarding-option">
              <Settings2 size={22} />
              <h3>Set up my own rooms</h3>
              <p>Add your own webinar or meeting IDs and links.</p>
              <button className="secondary-button full-width" type="button" onClick={() => onSelect('events')}>Set up my rooms</button>
            </section>
          ) : null}
          {showTeam ? (
            <section className="onboarding-option emphasized">
              <Users size={22} />
              <h3>Use our team's rooms</h3>
              <p>{user.orgOwner || 'Your admin'} set these up. Pick the rooms you will cover.</p>
              <div className="team-room-list">
                {teamRooms.map((room) => (
                  <label key={room.id}>
                    <input type="checkbox" defaultChecked />
                    <span>{room.is_vip ? 'VIP - ' : ''}{room.room_name || room.topic || `Room ${String(room.zoom_id || room.id)}`}</span>
                  </label>
                ))}
              </div>
              <button className="primary-button" type="button" onClick={() => onSelect('mod')}>Start moderating</button>
            </section>
          ) : null}
        </div>
      </section>
    </div>
  );
}
